import { useState, useEffect } from 'react';
import {
  Pane, Heading, Text, Button, Badge, Spinner, toaster,
  TickCircleIcon, DownloadIcon, EyeOpenIcon, Paragraph,
} from 'evergreen-ui';
import pagamentiService from '../../services/pagamentiService';
import useWindowSize from '../../utils/useWindowSize';

const MESI = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];

const triggerDownload = (url, filename) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const PagamentiCollaboratore = () => {
  const [bustePaga, setBustePaga] = useState([]);
  const [bonifici, setBonifici] = useState([]);
  const [loading, setLoading] = useState(true);
  const width = useWindowSize();
  const isMobile = width < 768;

  useEffect(() => {
    const load = async () => {
      try {
        const data = await pagamentiService.getMyDocuments();
        const all = data || [];
        setBustePaga(all.filter((d) => d.tipo === 'busta_paga'));
        setBonifici(all.filter((d) => d.tipo === 'bonifico'));
      } catch {
        toaster.danger('Errore nel caricamento dei documenti.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleView = async (doc) => {
    try {
      if (!doc.letto_at) {
        await pagamentiService.markAsRead(doc.id);
        const markRead = (prev) =>
          prev.map((d) => (d.id === doc.id ? { ...d, letto_at: new Date().toISOString() } : d));
        setBustePaga(markRead);
        setBonifici(markRead);
      }
      window.open(doc.file_url, '_blank');
    } catch {
      toaster.danger("Errore durante l'apertura del documento.");
    }
  };

  const renderDoc = (doc) => {
    return (
      <Pane
        key={doc.id}
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        alignItems={isMobile ? 'flex-start' : 'center'}
        justifyContent="space-between"
        padding={12}
        marginBottom={8}
        border="1px solid #E6E8F0"
        borderRadius={4}
        background="white"
        gap={8}
      >
        <Pane flex={1}>
          <Text
            fontWeight={500}
            cursor="pointer"
            color="#1070CA"
            onClick={() => handleView(doc)}
          >
            {doc.file_name}
          </Text>
          {doc.tipo === 'busta_paga' && doc.mese && doc.anno && (
            <Text size={300} color="muted" marginLeft={8}>
              {MESI[doc.mese - 1]} {doc.anno}
            </Text>
          )}
          <Pane display="flex" alignItems="center" marginTop={4}>
            {doc.letto_at ? (
              <>
                <TickCircleIcon color="success" size={12} marginRight={4} />
                <Text size={300} color="muted">
                  Letto il {new Date(doc.letto_at).toLocaleString('it-IT')}
                </Text>
              </>
            ) : (
              <Badge color="red">Non letto</Badge>
            )}
          </Pane>
        </Pane>

        <Pane display="flex" gap={8} flexShrink={0}>
          <Button
            iconBefore={EyeOpenIcon}
            appearance="minimal"
            onClick={() => handleView(doc)}
          >
            {!isMobile && 'Visualizza'}
          </Button>
          <Button
            iconBefore={DownloadIcon}
            appearance="minimal"
            onClick={() => triggerDownload(doc.file_url, doc.file_name)}
          >
            {!isMobile && 'Scarica'}
          </Button>
        </Pane>
      </Pane>
    );
  };

  if (loading) return <Spinner marginTop={32} />;

  return (
    <Pane>
      <Heading size={600} marginBottom={24}>I miei pagamenti</Heading>

      <Heading size={500} marginBottom={12}>Buste paga</Heading>
      {bustePaga.length === 0 ? (
        <Paragraph color="muted" marginBottom={24}>Nessuna busta paga disponibile.</Paragraph>
      ) : (
        <Pane marginBottom={24}>
          {bustePaga.map((doc) => renderDoc(doc))}
        </Pane>
      )}

      <Heading size={500} marginBottom={12}>Bonifici</Heading>
      {bonifici.length === 0 ? (
        <Paragraph color="muted">Nessun bonifico disponibile.</Paragraph>
      ) : (
        <Pane>
          {bonifici.map((doc) => renderDoc(doc))}
        </Pane>
      )}
    </Pane>
  );
};

export default PagamentiCollaboratore;
